export default class CSRFTokenResolver {
    /**
     * Get the CSRF Token
     * @returns {*|jQuery}
     */
    static getToken() {
        return $("meta[name='csrf-token']").attr('content');
    }
}
